import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/components/FloatingButtons.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/components/Footer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/components/HashScrollHandler.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/app/components/Navbar.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/@mui/material/Box/Box.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/next-intl/dist/esm/navigation/shared/BaseLink.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/next-intl/dist/esm/navigation/shared/LegacyBaseLink.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/next-intl/dist/esm/shared/NextIntlClientProvider.js");
